import { useUserLanguage } from '@/customHooks'
import { FC } from 'react'
import { Col, Row } from 'react-grid-system'
import styled from 'styled-components'

type PaymentAndBillingInfoCardProps = {
  rent: number
  deposit: number
  lateFee: number
}

const textsData = {
  en: {
    title: 'Billing & Payments',
    rent: 'Rent',
    deposit: 'Deposit',
    lateFees: 'Late Fees'
  },
  es: {
    title: 'Pagos y Facturas',
    rent: 'Alquiler',
    deposit: 'Depositos',
    lateFees: 'Cargos por Mora'
  }
}

const Wrapper = styled.div`
  & h3 {
    font-size: 0.8rem;
    line-height: 0.5rem;
  }
  & p {
    line-height: 0.5rem;
  }
`

export const PaymentAndBillingInfoCard: FC<PaymentAndBillingInfoCardProps> = ({ rent, deposit, lateFee }) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  return (
    <Wrapper>
      <Row>
        <Col>
          <h2>{texts.title}</h2>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <h3>{texts.rent}</h3>
          <p>{`$${rent.toFixed(2)}`}</p>
        </Col>
        <Col md={4}>
          <h3>{texts.deposit}</h3>
          <p>{`$${deposit.toFixed(2)}`}</p>
        </Col>
        <Col md={4}>
          <h3>{texts.lateFees}</h3>
          <p>{`$${lateFee.toFixed(2)}`}</p>
        </Col>
      </Row>
    </Wrapper>
  )
}